export class vwTaskId {
  Name : string;
  Id : number;
}
